import { Link } from "react-router-dom";
import { BRANDS, QUALITY } from "../../content/site";

export function QualityBlock({ compact = false }) {
  return (
    <section className="bg-[#F4F0EA]" data-testid="quality-block">
      <div className={`k-section ${compact ? "py-14" : ""}`}>
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="k-eyebrow">Qualité des textiles</p>
            <h2 className="k-h2 mt-3">{QUALITY.title}</h2>
            <p className="k-lead mt-5">{QUALITY.lead}</p>
            <p className="mt-6 text-xs uppercase tracking-[0.2em] text-[#8C857B]">Marques travaillées, parmi d'autres fournisseurs sélectionnés</p>
            <ul className="mt-3 flex flex-wrap gap-2" data-testid="brands-list">
              {BRANDS.map((b) => <li key={b} className="border border-[#1C1917]/30 px-3 py-1 text-sm font-medium">{b}</li>)}
            </ul>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {QUALITY.points.map(([t, d], i) => (
              <div key={t} className="border-t-2 border-[#1C1917] pt-5">
                <span className="font-mono-k text-xs text-[#C25E38]">0{i + 1}</span>
                <h3 className="font-display text-2xl mt-2">{t}</h3>
                <p className="text-sm text-[#57534E] mt-3 leading-relaxed">{d}</p>
              </div>
            ))}
            <p className="sm:col-span-2 text-sm text-[#57534E]">Une question sur un textile précis ? <Link to="/questions-frequentes" className="k-link">Voir les questions fréquentes</Link>.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
